import React, { createContext, useContext, useState } from "react";

// We intentionally split state and dispatch into two separate contexts so that
// pages which only need to *set* header actions (e.g. editors) do not re-render
// every time the actions node changes. Only the header itself subscribes to the
// state context.

const PageHeaderActionsStateContext = createContext<React.ReactNode | null>(null);
const PageHeaderActionsDispatchContext = createContext<((node: React.ReactNode | null) => void) | undefined>(
	undefined
);

/** Context provider for injecting action buttons into the page header. */
export const PageHeaderActionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [actions, setActions] = useState<React.ReactNode | null>(null);

	return (
		<PageHeaderActionsDispatchContext.Provider value={setActions}>
			<PageHeaderActionsStateContext.Provider value={actions}>{children}</PageHeaderActionsStateContext.Provider>
		</PageHeaderActionsDispatchContext.Provider>
	);
};

export const usePageHeaderActionsState = () => {
	return useContext(PageHeaderActionsStateContext);
};

export const usePageHeaderActionsDispatch = () => {
	const setActions = useContext(PageHeaderActionsDispatchContext);
	if (!setActions) {
		throw new Error("usePageHeaderActionsDispatch must be used within PageHeaderActionsProvider");
	}
	return setActions;
};
